import { getUser } from 'actions/user'
import { country } from 'config'
import { CountryContext } from 'contexts/CountryContext'
import React from 'react'
import { Redirect, Route } from 'react-router'

export default function UnProtectedRoute({ children, ...rest }) {
    return (
        <Route {...rest} render={() => {
            const parsedUser = getUser()
            if (parsedUser) {
                return <Redirect to={`/${country}`} />
            } else {
                return children
            }

        }} />
    )
}
